// Copy and locale-specific labels for the two static "This page has moved" pages.
// English is served at "/" and Spanish at "/?lang=es"; each page links to the
// other. Both are the site root, so no new route/CloudFront fallback is needed.
export const content = {
  en: {
    htmlLang: 'en',
    toggleHref: '/?lang=es',
    toggleLabel: 'En Español',
    heading: 'This page has moved',
    body:
      'Use the link we emailed you to access your Secured Card portal and see if ' +
      'you’re eligible to fund your card. You can also find this link in your ' +
      'approval letter.',
    logoAlt: 'Capital One',
    lockLabel: 'Secure connection',
    privacy: 'PRIVACY',
    security: 'SECURITY',
    terms: 'TERMS & CONDITIONS',
    fdicLabel: 'Member FDIC',
    equalHousing: 'Equal Housing Lender',
  },
  es: {
    htmlLang: 'es',
    toggleHref: '/',
    toggleLabel: 'In English',
    heading: 'Esta página se ha trasladado',
    body:
      'Usa el enlace que te enviamos por email para obtener acceso al portal de tu ' +
      'Tarjeta de Crédito con Depósito de Garantía y ver si calificas para depositar ' +
      'fondos en tu tarjeta. También puedes encontrar este enlace en tu carta de aprobación.',
    logoAlt: 'Capital One',
    lockLabel: 'Conexión segura',
    privacy: 'PRIVACIDAD',
    security: 'SEGURIDAD',
    terms: 'TÉRMINOS Y CONDICIONES',
    fdicLabel: 'Member FDIC',
    equalHousing: 'Prestamista de Viviendas',
  },
};

// Locale-independent outbound links, matching the previous footer/header.
export const links = {
  capitalOne: 'https://www.capitalone.com',
  privacy: 'http://www.capitalone.com/identity-protection/privacy/?linkid=WWW_Z_Z_Z_GBLFO_F1_01_T_FO1',
  security: 'http://www.capitalone.com/identity-protection/commitment/?linkid=WWW_Z_Z_Z_GBLFO_F1_02_T_FO4',
  terms: 'http://www.capitalone.com/legal/terms-conditions/?linkid=WWW_Z_Z_Z_GBLFO_F1_03_T_FO5',
  fdic: 'http://www.fdic.gov/',
};

// Resolve the active locale from the query string (?lang=es -> Spanish).
// Using a query param keeps everything on the root object, so no new route
// or CloudFront fallback is required for the Spanish page to resolve.
export const localeFromSearch = (search) => {
  const lang = new URLSearchParams(search || '').get('lang');
  return (lang || '').toLowerCase() === 'es' ? 'es' : 'en';
};
